import type React from 'react';

import { Input } from '../ui/input';
import { Label } from '../ui/label';

interface InputFieldProps extends Omit<React.ComponentProps<typeof Input>, 'name'> {
	label?: string;
	name: string;
	placeholder?: string;
	restProps?: React.ComponentProps<typeof Input>;
	setControlValue?: string;
	onClickMethod?: () => void;
}

function InputField(props: InputFieldProps) {
	const { label, name, placeholder, setControlValue, onClickMethod, restProps, onClick, className, ...inputProps } = props;

	return (
		<div className="w-full">
			{label && <Label htmlFor={name}>{label}</Label>}
			<Input
				autoComplete="off"
				className={`h-11 ${className ?? ''}`}
				id={name}
				name={name}
				placeholder={placeholder}
				value={setControlValue}
				{...restProps}
				{...inputProps}
				onClick={(event) => {
					onClick?.(event);
					onClickMethod?.();
				}}
			/>
		</div>
	);
}

export default InputField;
